﻿import {translation} from "@2d-front-monorepo/core";
import {FC, memo} from "react";
import {attachmentStatusLabel, attachmentStatusName} from "../helpers/enumNaming";
import {AttachmentResult} from "../types/AttachmentResult";

interface AttachmentStatusProps {
	attachment: AttachmentResult;
	small: boolean;
}

export const AttachmentStatusComponent: FC<AttachmentStatusProps> = memo(({attachment, small}) => {
		const pillClass = `pill__attachment-status--${attachmentStatusName(attachment.status)}`;
		const label = translation(attachmentStatusLabel(attachment.status));
		return small
			? (<abbr title={label} className={`pill ${pillClass} pill--small`}>{label[0]}</abbr>)
			: (<span className={`pill ${pillClass} pill--small`}>{label}</span>);
	},
	(prevProps, nextProps) => {
		return prevProps.small === nextProps.small && prevProps.attachment.status === nextProps.attachment.status;
	}
);
